var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBtnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#335089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5888ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10157",
    "data-name": "Group 10157",
    transform: "translate(-500 -1957)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4176",
    "data-name": "Rectangle 4176",
    width: 21,
    height: 21,
    rx: 10.5,
    transform: "translate(500 1957)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-check",
    "data-name": "Icon material-check",
    d: "M9.891,17.425,6.328,13.862l-1.213,1.2,4.776,4.776L20.145,9.59l-1.2-1.2Z",
    transform: "translate(497.87 1953.67)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBtnIcon);
export default __webpack_public_path__ + "static/media/checkBtnIcon.6ebd77ce41683ecb7360fbbc7eb4fa36.svg";
export { ForwardRef as ReactComponent };